module.exports = __webpack_public_path__ + "img/horizontal_bar_chart.e9ded661.svg";